import { publicRoutes } from "@/application/router/public";
import { contractRoutes } from "@/application/router/contracts";
import { checkupRoutes } from "@/application/router/checkup";
import { documentRoutes } from "@/application/router/documents";
import { hintRoutes } from "@/application/router/hints";
import { handlungenRoutes } from "@/application/router/handlungen.ts";
import { accountRoutes } from "@/application/router/account";
import { bedarfRoutes } from "@/application/router/bedarf";
import { notFoundRoute } from "@/application/router/404";
import { bankingRoutes } from "@/banking/routes/banking.ts";

export const routes = [
  ...publicRoutes,
  ...contractRoutes,
  ...checkupRoutes,
  ...bedarfRoutes,
  ...documentRoutes,
  ...hintRoutes,
  ...handlungenRoutes,
  ...accountRoutes,
  ...bankingRoutes,
  ...notFoundRoute,
]
